import axios from 'axios';
import { DHLError, axiosRequest, handleHttpResponse, SubmitPolicyError, SubmitPolicyInProcessError, SubmitPolicyTimeoutError } from '@general/js/utils';
import { PolicyErrorCodesEnum } from '@general/js/enums';
import { getCurrentDate } from '@general/js/utils/dateTimeUtils';
import { Services } from '@/services/Services';
import { EnvironmentVariables } from '@general/js/environmentVariables';
import ChangeExcessAbstractServices from './ChangeExcessAbstractServices';

export default class ChangeExcessServices extends ChangeExcessAbstractServices {
  static async getReferenceData() {
    try {
      const response = await axios.get(Services.MY_COVER.CHANGE_COVER.CHANGE_EXCESS.GET_REFERENCE_DATA);

      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getCoverDetails() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async getPremiumImpactReferenceData() {
    try {
      const response = await axios.get(Services.MY_COVER.CHANGE_COVER.CHANGE_EXCESS.GET_PREMIUM_IMPACT_REFERENCE_DATA);

      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getCoverDetails() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async getCoverDetails(memberNumber) {
    try {
      const response = await axiosRequest().get(Services.MY_COVER.CHANGE_COVER.RETRIEVE_COVER_DETAILS(memberNumber, getCurrentDate(), true));

      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getCoverDetails() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async getPremiumOnNewExcess(memberNumber, excess) {
    try {
      const response = await axiosRequest().get(Services.MY_COVER.CHANGE_COVER.CHANGE_EXCESS.GET_PREMIUM_ON_NEW_EXCESS(memberNumber, excess, true));

      return handleHttpResponse(response);
    } catch (error) {
      throw new DHLError(`getPremiumOnNewExcess() - Call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }

  static async submitNewExcess(memberNumber, payload) {
    try {
      const response = await axiosRequest().patch(Services.MY_COVER.CHANGE_COVER.CHANGE_EXCESS.SUBMIT_NEW_EXCESS(memberNumber), payload, {
        timeout: Number(EnvironmentVariables.MemberPortalTimeout.TIMEOUT),
      });
      return handleHttpResponse(response);
    } catch (error) {
      const policyErrorCode = error?.response?.data?.Error?.Code;
      if (policyErrorCode === PolicyErrorCodesEnum.SUBMIT_POLICY_ERROR) {
        throw new SubmitPolicyError(`getPremiumOnNewExcess() - call failed with error: ${JSON.stringify(error.response.data.Error.ErrorMessage)}`, error.response.data.Error);
      } else if (error.code === PolicyErrorCodesEnum.TIMEOUT_ERROR) { // error.code is set by axios upon timeout
        throw new SubmitPolicyTimeoutError(`getPremiumOnNewExcess() - call failed with error: ${JSON.stringify(error.message)}`, error);
      } else if (policyErrorCode === PolicyErrorCodesEnum.SUBMIT_POLICY_IN_PROCESS_ERROR) {
        throw new SubmitPolicyInProcessError(`getPremiumOnNewExcess() - call failed with error: ${JSON.stringify(error.response.data.Error.ErrorMessage)}`, error.response.data.Error);
      }
      throw new DHLError(`getPremiumOnNewExcess() - call failed with error: ${JSON.stringify(error.message)}`, error);
    }
  }
}
